import React from 'react'
import { Helmet } from 'react-helmet'
import EshopCategory from './EshopCategory'

const EshopPetit = ({ products = [], eshopInfo = null }) => (
    <>
        <Helmet>
            <title>Petit format | Marguerite Soulier</title>
            <link rel="canonical" href="https://margueritesoulier.fr/petit-format" />
            <meta property="og:url" content="https://margueritesoulier.fr/petit-format" />
        </Helmet>
        <EshopCategory products={products} category="petit" eshopInfo={eshopInfo} />
    </>
)

export default EshopPetit